import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SELECTED_PROJECT, SELECTED_UNIT_ID } from "Stores/actionTypes";
import { read } from "Helpers/LocalStorage";
import Header from "hoc/AdminLayout/components/Header/Header";

function DesignHeader() {
  const {  isLoggedIn, rtlLayout } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
    rtlLayout: state.settings.rtlLayout
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn) {
      dispatch({ type: SELECTED_PROJECT, selectedProject: read("project") });
      dispatch({ type: SELECTED_UNIT_ID, selectedUnitId: read("unitId") });
    }
  }, [isLoggedIn]);

  return <Header rtlLayout={rtlLayout} isDesign={true}/>;
}

export default DesignHeader;
